import ScratchLotteryTicket from './ScratchLotteryTicket';
import styles from './lottery-ticket.module.less';
import { ContentTitle } from '../../components/typography/Heading';

const ScratchLotteryTicketContainer = (props) => (
    <div className={styles.cmsContainer}>
        <ContentTitle>Skrap et testlodd</ContentTitle>
        <ScratchLotteryTicket {...props} />
    </div>
);

export default ScratchLotteryTicketContainer;
